import data from "../../.sourceflow/jobs.json";
import CollectionHelper from "@/helpers/CollectionHelper";

class JobsCollectionHelper extends CollectionHelper {
  fetch({
    limit = null,
    featured = null,
    sector = null,
    practice_area = null,
    branch = null,
    exclude = null,
    filter = null,
  } = {}) {
    let items = this.collection.getItems();

    if (filter) {
      items = items.filter(filter);
    }

    if (sector) {
      items = items.filter((i) => JSON.stringify(i.categories).includes(sector));
    }

    if (practice_area) {
      const areas = Array.isArray(practice_area) ? practice_area : [practice_area];
      items = items.filter((job) =>
        job.categories.some(
          (cat) =>
            cat.id === "d33d76e6-e4fd-4ad7-b916-e9399e7dc518" && // Practice Area category
            cat.values?.some((val) => areas.includes(val.id)),
        ),
      );
    }

    if (branch) {
      items = items.filter((i) => JSON.stringify(i.categories).includes(branch));
    }

    if (featured) {
      items = items.filter((i) => i.featured === featured);
    }

    if (exclude) {
      items = items.filter((i) => !exclude.includes(i.id));
    }

    if (limit) {
      items = items.slice(0, limit);
    }

    return items;
  }
  getCategoryValues(search, { categories }) {
    const category = categories.find((i) => i.id === search || i.name === search);

    if (!category) {
      return [];
    }

    return category.values;
  }

  getCategoryValueIds(search, { categories }) {
    return this.getCategoryValues(search, { categories }).map((i) => i.id);
  }
}

export const jobs_fetcher = new JobsCollectionHelper(data.jobs);
